import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";
import { translate } from "@/helper/translate";

interface HelpGuideSmartScribeProps {
    onClose: () => void;
}

export const HelpGuideSmartScribe = ({
    onClose,
}: HelpGuideSmartScribeProps) => {
    return (
        <div>
            <ModalHeader
                title="Smart Scribe"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    Smart Scribe is our flagship AI writing feature that helps
                    you create compelling, professional content for your resume.
                </AppText>

                <div className="mb-2">
                    <h4 className="font-semibold">Key Features:</h4>
                    <ul className="ml-4 list-disc">
                        <li>
                            <AppText variant="regular">
                                <strong>Paragraph Pro:</strong> Generate
                                professional paragraphs for any resume section
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                <strong>Bullet Builder:</strong> Create
                                impactful bullet points with proper formatting
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                <strong>Quick Prompts:</strong> Refine text with
                                rewrite (improve clarity), shorten (condense),
                                formal (professional tone), or grammar (fix
                                errors)
                            </AppText>
                        </li>
                    </ul>
                </div>

                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    Simply select any section of your resume and choose the
                    Smart Scribe option that best fits your needs. The AI will{" "}
                    {translate("analyse")} your input and generate professional,
                    industry-standard content tailored to your specific section
                    type. You can also use the Quick Prompts to refine your
                    content with options like rewrite, shorten, formal, or
                    grammar.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
